import { VoyageFuelPriceBM } from '../types/BusinessModel/VoyageFuelPriceBM';
import { VoyageFuelPrice } from '../types/ViewModel/VoyageFuelPrice';

export class VoyageFuelPriceFactory {
    public create(data: VoyageFuelPriceBM): VoyageFuelPrice {
        return new VoyageFuelPrice(
            data.voyageNumber,
            data.hfoPrice,
            data.mgoPrice,
            data.hfoOnlyPrice,
            data.lsfOnlyPrice,
            data.bioPrice,
            data.startDateTime,
            data.endDateTime
        );
    }

    public createList(data: VoyageFuelPriceBM[]): VoyageFuelPrice[] {
        return data.map((h) => this.create(h));
    }
}
